import RightIcon from '@/assets/icons/right.svg';
import SuperVoiceBg from '@/assets/images/superVoice/sv-bg.png';
import SuperVoiceEmptyBg from '@/assets/images/superVoice/sv-empty-bg.png';
import AudioList from '@/pages/Home/components/AudioList';
import { useModel } from '@/pages/Home/Generator/model';

import { useNavigate } from 'react-router-dom';
import { useSuperVoiceList } from '../hooks';

export const TrackList = () => {
  useModel();
  const { superVoiceList } = useSuperVoiceList();
  const mockTrackList = [];

  if (superVoiceList.filter((item) => item.status === 'success').length === 0) {
    return <EmptyToCreateSuperVoice />;
  }
  if (!mockTrackList.length) {
    return <EmptyToCreateTrack />;
  }
  return (
    <div className="">
      <AudioList onlyShowList actionShowConfig={{ showEllipsisAction: false, showFolder: false, showLike: false, showTime: true }} />
    </div>
  );
};

const EmptyToCreateSuperVoice = () => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center gap-10 px-6 pt-9">
      <div
        className="flex-shrink-0 w-[312px] h-[501px] bg-jenmusic-interactive rounded-2xl"
        style={{
          background: `url(${SuperVoiceBg})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow:
            '101.008px 158.919px 52.524px 0px rgba(0, 0, 0, 0.00), 64.645px 101.008px 48.484px 0px rgba(0, 0, 0, 0.03), 36.363px 56.565px 40.403px 0px rgba(0, 0, 0, 0.10), 16.161px 25.589px 29.629px 0px rgba(0, 0, 0, 0.17), 4.04px 6.734px 16.161px 0px rgba(0, 0, 0, 0.20)',
        }}
      ></div>
      <div className="">
        <div className=" typography-jenmusic-display-small">Creating a SuperVoice Filter</div>
        <div className=" mt-3 mb-4 typography-jenmusic-base text-jenmusic-content-tertiary">
          Before you make a track using SuperVoice you will need to create a filter. This filter will define what the voice sounds like when
          you apply it to a separate track.
        </div>
        <div className="flex gap-1 hover:opacity-80 cursor-pointer items-center" onClick={() => navigate('/super_voice/create')}>
          <div className=" rounded-full bg-jenmusic-interactive-accent w-6 h-6 flex justify-center items-center ">
            <RightIcon className=" fill-jenmusic-interactive" />
          </div>
          <div className="text-jenmusic-interactive typography-jenmusic-base">Start Jenerating</div>
        </div>
      </div>
    </div>
  );
};

const EmptyToCreateTrack = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full mx-auto px-6">
      <div
        className=" mb-[37px] flex-shrink-0 w-full aspect-[807/370] w-full mx-auto bg-jenmusic-interactive rounded-2xl"
        style={{
          background: `url(${SuperVoiceEmptyBg})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      ></div>
      <div className=" typography-jenmusic-display-small  flex justify-between gap-[105px]">
        <div className="w-[282px]">Creating a SuperVoice Track</div>
        <div className="flex-grow flex flex-col gap-4">
          <div className="typography-jenmusic-base text-jenmusic-content-tertiary">
            Making a track with SuperVoice is simple now that you have made a SuperVoice Filter. Simply apply the filter to a new track that
            you upload to get started. Pellentesque at odio non massa interdum elementum. Cras at pharetra felis, ut scelerisque mi. Nam
            tellus risus, consequat quis convallis ultrices, accumsan nec felis. Phasellus in lectus mi. Duis non rhoncus mauris. Sed
            consectetur dui nec convallis sodales.
          </div>
          <div className="flex gap-1 hover:opacity-80 cursor-pointer items-center" onClick={() => navigate('/super_voice/track_create')}>
            <div className=" rounded-full bg-jenmusic-interactive-accent w-6 h-6 flex justify-center items-center ">
              <RightIcon className=" fill-jenmusic-interactive" />
            </div>
            <div className="text-jenmusic-interactive typography-jenmusic-base">Create a SuperVoice Track</div>
          </div>
        </div>
      </div>
    </div>
  );
};
